import {Button, Modal, Spinner} from "@tag/tag-components-react-v4";
import React, {useEffect, useState} from "react";
import styles from './OrganisationInfoModal.module.scss'
import {OrganisationDTO} from "../../types/OrganisationDTO";
import WorkspaceDetails from "./WorkspaceDetails";
import DataEngineDetails from "./DataEngineDetails";
import { ProjectAccents } from "../../../General/config/projectAccents";

function OrganisationInfoModal(props: {selectedOrganisation: OrganisationDTO, handleClose: Function}) {

    const [loading, setLoading] = useState<string|boolean>(false);
    const [workspaceDetailsVisible, setWorkspaceDetailsVisible] = useState(false);
    const [dataEngineDetailsVisible, setDataEngineDetailsVisible] = useState(false);
    
    let content;
    if (loading) {
        content = <Spinner full={true} >{loading}</Spinner>;
    }
    else {
        content = <>
            <Modal
                visible={!!props.selectedOrganisation}
                accent={ProjectAccents.PoliciesAndProcedures}
                heading={props.selectedOrganisation?.displayedName}
                primaryButtonProps={{buttonStyle: {'display': 'none'}}}
                onCancelButtonClick={() => {
                    props.handleClose();
                }}
                onClose={() => props.handleClose()}
            >
                <div className={styles.OrganisationInfoModalButtonContainer}>
                    <div className={styles.OrganisationInfoModalButtonElement}>
                        <Button text={'Workspace'} onClick={() => setWorkspaceDetailsVisible(true)}/>
                    </div>
                    <div className={styles.OrganisationInfoModalButtonElement}>
                        <Button text={'Data Engine'} onClick={() => setDataEngineDetailsVisible(true)}/>
                    </div>
                </div>
            </Modal>
        </>
    }

    return (
        <>
            {content}
            {workspaceDetailsVisible ?
                <WorkspaceDetails
                    visible={workspaceDetailsVisible}
                    selectedOrganisation={props.selectedOrganisation}
                    handleClose={() => setWorkspaceDetailsVisible(false)}
                /> : undefined
            }
            {dataEngineDetailsVisible ?
                <DataEngineDetails
                    visible={dataEngineDetailsVisible}
                    selectedOrganisation={props.selectedOrganisation}
                    handleClose={() => setDataEngineDetailsVisible(false)}
                /> : undefined
            }
        </>
    )

}

export default OrganisationInfoModal;
